import React, { Component } from 'react'
import { Paper, RaisedButton, TextField } from 'material-ui'

const style = {
  layout: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    padding: '24px',
    background: 'linear-gradient(135deg, #f4f1ea 0%, #ffffff 55%, #e8f1ec 100%)'
  },
  paper: {
    width: '100%',
    maxWidth: '720px',
    padding: '28px'
  },
  title: {
    fontSize: '28px',
    fontWeight: 600,
    marginBottom: '8px'
  },
  subtitle: {
    fontSize: '15px',
    lineHeight: 1.6,
    marginBottom: '24px',
    color: '#4d5b63'
  },
  field: {
    width: '100%'
  },
  readonly: {
    width: '100%',
    marginTop: '16px'
  },
  button: {
    marginTop: '24px'
  },
  label: {
    fontSize: '12px',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    color: '#6c7b84',
    marginTop: '20px'
  },
  meta: {
    marginTop: '8px',
    lineHeight: 1.7,
    color: '#2d3a40'
  },
  error: {
    marginTop: '16px',
    color: '#c62828'
  }
}

class ShopifyInstall extends Component {
  constructor(props) {
    super(props)

    this.state = {
      shop: '',
      loading: true,
      submitting: false,
      error: '',
      callbackUrl: '',
      configured: false,
      installedAt: '',
      scopes: '',
      tokenPreview: ''
    }
  }

  componentDidMount() {
    this.loadStatus()
  }

  loadStatus = () => {
    const url =
      process.env.REACT_APP_NODE_ROOT_URL +
      '/api/shopify/oauth/status?appOrigin=' +
      encodeURIComponent(window.location.origin)

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        if (!data.success) {
          throw new Error(data.error || 'Unable to load Shopify OAuth status')
        }

        this.setState({
          loading: false,
          callbackUrl: data.callbackUrl || '',
          configured: Boolean(data.configured),
          installedAt: data.installedAt || '',
          scopes: data.scopes || '',
          tokenPreview: data.tokenPreview || '',
          shop: data.shop || ''
        })
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error.message || 'Unable to load Shopify OAuth status'
        })
      })
  }

  handleChange = (event) => {
    this.setState({
      shop: event.target.value,
      error: ''
    })
  }

  startOauth = () => {
    this.setState({ submitting: true, error: '' })

    fetch(process.env.REACT_APP_NODE_ROOT_URL + '/api/shopify/oauth/start', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        shop: this.state.shop,
        appOrigin: window.location.origin
      })
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.success || !data.authUrl) {
          throw new Error(data.error || 'Unable to start Shopify OAuth')
        }

        window.location.assign(data.authUrl)
      })
      .catch((error) => {
        this.setState({
          submitting: false,
          error: error.message || 'Unable to start Shopify OAuth'
        })
      })
  }

  renderConfiguredState() {
    if (!this.state.configured) {
      return null
    }

    return (
      <div style={style.meta}>
        <div><strong>Installed shop:</strong> {this.state.shop}</div>
        <div><strong>Saved scopes:</strong> {this.state.scopes || 'Not reported by Shopify'}</div>
        <div><strong>Token:</strong> {this.state.tokenPreview || 'Stored'}</div>
        <div><strong>Installed:</strong> {this.state.installedAt || 'Unknown'}</div>
      </div>
    )
  }

  render() {
    return (
      <div style={style.layout}>
        <Paper style={style.paper} zDepth={4}>
          <div style={style.title}>Shopify OAuth Setup</div>
          <div style={style.subtitle}>
            Use this page to start the Shopify app install flow and register the redirect URL Shopify needs.
          </div>

          <TextField
            floatingLabelText="Shop Domain"
            hintText="your-store.myshopify.com"
            value={this.state.shop}
            onChange={this.handleChange}
            fullWidth
            style={style.field}
          />

          <RaisedButton
            label={this.state.submitting ? 'Redirecting...' : 'Connect Shopify'}
            primary
            disabled={this.state.loading || this.state.submitting}
            onClick={this.startOauth}
            style={style.button}
          />

          <div style={style.label}>Callback URL for Shopify app registration</div>
          <TextField
            value={this.state.callbackUrl}
            fullWidth
            style={style.readonly}
            inputStyle={{ color: '#1f2a30' }}
          />

          {this.renderConfiguredState()}

          {this.state.error ? <div style={style.error}>{this.state.error}</div> : null}
        </Paper>
      </div>
    )
  }
}

export default ShopifyInstall
